/**
 * @generated SignedSource<<88919ecb8e7fce9c0723d3722185f3e6>>
 * @relayHash 5d07961fac73a5210773223b5cd893f7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID edfb299ffd5dd19387350c1ac7ec1ac207c0c61cc73a1e3a853b4c40d5f1cfbe

import type { ConcreteRequest } from 'relay-runtime';
export type spacekeyResolverQuery$variables = {
  cql: string;
};
export type spacekeyResolverQuery$data = {
  readonly search: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityType: string | null;
        readonly space: {
          readonly icon: {
            readonly path: string;
          } | null;
          readonly key: string | null;
        } | null;
        readonly title: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type spacekeyResolverQuery = {
  response: spacekeyResolverQuery$data;
  variables: spacekeyResolverQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cql"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "cql",
    "variableName": "cql"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 25
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "entityType"
},
v3 = {
  "kind": "ScalarField",
  "name": "title"
},
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "spacekeyResolverQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConfluenceSearchResponse",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "spacekeyResolverQuery",
    "selections": [
      {
        "alias": "search",
        "args": (v1/*: any*/),
        "concreteType": "ConfluenceSearchConnection",
        "kind": "LinkedField",
        "name": "confluence_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConfluenceSearchResponseEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConfluenceSearchResponse",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "concreteType": "Space",
                    "kind": "LinkedField",
                    "name": "space",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "id"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "5d07961fac73a5210773223b5cd893f7",
    "id": "edfb299ffd5dd19387350c1ac7ec1ac207c0c61cc73a1e3a853b4c40d5f1cfbe",
    "metadata": {},
    "name": "spacekeyResolverQuery",
    "operationKind": "query",
    "text": "query spacekeyResolverQuery($cql:String!){search:confluence_search(cql:$cql,first:25){edges{node{entityType,title,space{key,icon{path},id}}}}}"
  }
};
})();

(node as any).hash = "c4344d7ac01abb756ffa63aecca5d833";

export default node;
